const initialState = { queue: [], notify: [] }

const requests = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default requests
